<template>
<section>
    <policy-filter :filter="this.filter" :isSupport="true" @changeFilter="changeFilter"/>
    <div v-if="loadedFilter" class="rounded border h-200px bg-white info-panel custom-table">
      <loader-full />
    </div>
    <template v-else>
      <policies-support
          v-if="policies && policies.hasOwnProperty('data')  && policies.data"
          :policies="policies"
          @open="openPolicyModal"
          @reloaded="getPolicies"/>
      <policy-modal
          v-if="policyItem"
          :policy="policyItem.policy"
          :support-info="policyItem"
          :loading="loading"
          @rescind="rescind"
          @dissolution="dissolution"
          @rejectSupport="rejectSupport"
      />
    </template>
  </section>
</template>

<script>
import PolicyFilter      from '@/components/Policy/PolicyFilter'
import PolicyModal       from '@/components/Modals/Policy/PolicyModal.vue'; 
import PoliciesSupport   from '@/components/Policy/PoliciesSupport.vue';
import LoaderFull           from '@/components/Main/LoaderFull'
// Library
import axios from 'axios'

export default {
  name: 'OperatorError',
  components: {PolicyFilter, PoliciesSupport, LoaderFull, PolicyModal},
  data() {
    return {
      loadedFilter: false,
      policyItem:   null,
      policies:     null,
      loading:      false,
      loadingText:  '',
      filter: {
        isGlobal: false,
        created:  '',
        manager:  '',
        creator:  '',
        global:   '',
        status:   '',
        one_c:    '',
        start:    '',
        end:      '',
        iin:      '',
        apc:      this.$user.apc ?? ''
      },
    }
  },
  computed: {
  },
  mounted() {
    this.getPolicies()
  },
  methods: {
    getPolicies(page = 1) {
      this.loadedFilter = true
      this.dataKey      = 0
      const headers     = {headers: {}, params: this.filter}
      axios.get('/api/support/policy/get-operator-errors?page=' + page, headers)
          .then(res  => {
            this.policies = res.data
          })
          .catch(err => { console.log(err) })
          .finally(() => {if (this.loadedFilter) this.loadedFilter = false})
    },
    changeFilter(val) {
      val.hasOwnProperty('global') ? this.filter = val : this.loadedFilter = val
      this.getPolicies()
    },
    openPolicyModal(val) {
      this.policyItem = val
      setTimeout(() => {new bootstrap.Modal('#policiesModal', {}).show()}, 10)
    },
    policiesModalHidden() {
      const myModalEl = document.getElementById('policiesModal');
      const modal     = bootstrap.Modal.getInstance(myModalEl);
      modal.hide();
    },
    rescind(data) {
      this.loading      = true
      this.loadingText  = 'Оформление "Ошибка оператора"'
      const headers     = {id: data.id}
      axios.post('/api/support/policy/rescind', headers)
          .then(res  => {
            if (res.data.result) {
              this.$emit('reload', true)
              this.policiesModalHidden()
            } else {
              this.$notifyError(res.data)
              this.step = 1
            }
          })
          .catch(err => {
            this.$notifyError(err)
          })
          .finally(() => {
            this.loading = false
            this.loadingText = ''
          })
    },
    dissolution() {
      this.$notifyError({message: 'Данная операция недоступна'})
    },
    rejectSupport(id) {
      const headers     = {id: id}
      axios.post('/api/support/policy/reject', headers)
          .then(res  => {
            if (res.data.result) {
              this.$emit('reload', true)
              this.policiesModalHidden()
            } else {
              this.$notifyError(res.data)
              this.step = 1
            }
          })
          .catch(err => {
            this.$notifyError(err)
          })
          .finally(() => {
            this.loading = false
            this.loadingText = ''
          })
    }
  }
}
</script>

<style scoped>

</style>